var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdInventoryRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "store-line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.067,
    height: 16.683,
    viewBox: "0 0 19.067 16.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M19.108,26.767h-7.15V22H10.767v4.767H7.192V22H6v4.767a1.192,1.192,0,0,0,1.192,1.192H19.108A1.192,1.192,0,0,0,20.3,26.767V22H19.108Z",
    transform: "translate(-3.617 -11.275)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M20.941,9.523,18.51,4.661A1.192,1.192,0,0,0,17.444,4H5.623a1.192,1.192,0,0,0-1.067.661L2.125,9.523A1.192,1.192,0,0,0,2,10.06v1.835a1.192,1.192,0,0,0,.274.763,2.783,2.783,0,0,0,2.109.953,2.812,2.812,0,0,0,1.787-.638,2.818,2.818,0,0,0,3.575,0,2.818,2.818,0,0,0,3.575,0,2.818,2.818,0,0,0,3.575,0,2.812,2.812,0,0,0,3.891-.31,1.192,1.192,0,0,0,.28-.763V10.06a1.192,1.192,0,0,0-.125-.536Zm-2.258,2.9a1.6,1.6,0,0,1-1.3-.673l-.489-.667-.483.667a1.615,1.615,0,0,1-2.6,0l-.489-.667-.483.667a1.615,1.615,0,0,1-2.6,0l-.489-.667-.483.667a1.615,1.615,0,0,1-2.6,0l-.489-.667-.489.667a1.6,1.6,0,0,1-1.3.673,1.573,1.573,0,0,1-1.192-.524V10.06L5.623,5.192H17.444l2.431,4.862v1.823A1.591,1.591,0,0,1,18.683,12.419Z",
    transform: "translate(-2 -4)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdInventoryRequest);
export default __webpack_public_path__ + "static/media/ad-inventory-request.de11ec552ef61eb47d88a1384bf8cceb.svg";
export { ForwardRef as ReactComponent };